import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { toast } from "react-toastify";
import Radio from "@mui/material/Radio";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import {
  DELETE_CLIENT_EXPENSES_RECEIPTS,
  FETCH_CLIENT_CURRENCIES_V2,
  FETCH_CLIENT_EXPENSE_CODES,
  FETCH_CLIENT_EXPENSES,
  FETCH_CLIENT_JOBS,
  FETCH_CLIENT_UD_FIELDS_BY_CLIENT_ID,
  SAVE_CLIENT_EXPENSE_RECEIPT,
  SAVE_CLIENT_EXPENSES
} from "../../constant/Apipath";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

function AddClientExpenses({ open, handleClose, currentClientExpensesId }) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const { selectedClientData } = useSelector((state) => state?.main);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [pictureViewerIndex, setPictureViewerIndex] = useState(0);

  const imgRef = useRef(null);

  const {
    TEXT_DATE,
    TEXT_TITLE,
    TEXT_TITLE_PLACEHOLDER,
    TEXT_CODE,
    TEXT_SELECT_CODE,
    TEXT_JOB,
    TEXT_AMOUNT,
    TEXT_IN_REVIEW,
    TEXT_TOTAL,
    TEXT_TAX_OPTIONAL,
    TEXT_TIP_OPTIONAL,
    TEXT_SELECT1,
    TEXT_PAID_WITH_COMPANY,
    TEXT_DESCRIPTION,
    TEXT_PAID_PERSONALLY,
    TEXT_INCLUDE_ADDTITIONAL_DETAIL,
    TEXT_UPLOAD_RECEIPT,
    TEXT_SUBMIT,
    TEXT_MILEAGE
  } = ClientEnglishFallback.ClientAddExpenses(multiLanguageData?.ClientAddExpenses || {});

  const { TEXT_SUB_TOTAL } = ClientEnglishFallback.ClientViewExpenses(
    multiLanguageData?.ClientViewExpenses || {}
  );

  const [expenseCodeData, setExpenseCodeData] = useState([]);
  const [jobData, setJobData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [udFieldData, setUdFieldData] = useState([]);
  const [clientExpensesSaveData, setClientExpensesSaveData] = useState({
    id: 0,
    date: dayjs(),
    code: { id: -1, name: TEXT_SELECT_CODE },
    job: [],
    milageUnit: { id: 1, unitLabel: "km" },
    mileageValue: 0,
    amount: "",
    currType: {},
    tax: "",
    tip: "",
    total: "",
    description: "",
    paidWith: 1,
    title: "",
    imageFile: [],
    imageFileOld: [],
    status: TEXT_IN_REVIEW,
    deleteImgId: []
  });
  const unitData = [
    { id: 1, unitLabel: "km" },
    { id: 2, unitLabel: "mi" }
  ];
  const [isMore, setIsMore] = useState(false);

  useEffect(() => {
    getInitialData();
  }, []);

  const getInitialData = async () => {
    let getExpCodes = await getClientExpenseCode();
    let getCurrencies = await getClientCurrencies();
    await getClientJob();
    if (
      currentClientExpensesId &&
      !isNaN(currentClientExpensesId) &&
      typeof currentClientExpensesId !== "object"
    ) {
      await getSingleExpensesData(currentClientExpensesId, getExpCodes);
    } else {
      let getCad = getCurrencies?.filter((item) => item?.currencyCode === "CAD");
      setClientExpensesSaveData({
        ...clientExpensesSaveData,
        currType: getCad[0] || {}
      });
    }
    setIsLoading(false);
  };

  const getSingleExpensesData = async (currentClientExpensesId, getExpCodes) => {
    setIsLoading(true);
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 1,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            CreatedBy: loginData?.userInformation?.UserId,
            Id: currentClientExpensesId
          }
        ],
        SortList: [
          {
            FieldName: "dateSubmitted",
            Direction: "DESC"
          }
        ],
        TypeOfObjectReturned: ""
      };
      const clientExpensesResponse = await Postrequestcall(
        FETCH_CLIENT_EXPENSES,
        obj,
        loginData?.accessToken
      );
      if (clientExpensesResponse?.status === 200) {
        const data = clientExpensesResponse?.data?.data[0];
        let getSelectedExpCodes = getExpCodes?.filter(
          (item) => item.id === data.clientExpenseCodeId
        );
        setClientExpensesSaveData({
          ...clientExpensesSaveData,
          id: data.id,
          date: data.dateSubmitted,
          code: getSelectedExpCodes?.length > 0 ? getSelectedExpCodes[0] || {} : {},
          job: { id: data.clientJobId },
          milageUnit: { id: data.mileageUnit === "km" ? 1 : 2 },
          mileageValue: data.mileage,
          amount: data.subTotal,
          currType: {
            id: data.currencyId,
            currencyCode: data?.currencyCode,
            currencySign: data?.currencySign
          },
          tax: data.tax,
          tip: data.tip,
          total: data.total,
          description: data.description,
          paidWith: data.paidWith,
          title: data.title,
          imageFileOld: data.expenseReceiptList,
          status: data?.status === 1 ? TEXT_IN_REVIEW : ""
        });
      } else {
        console.log("getSingleExpensesData->Error When Getting Client Expenses Data");
      }
    } catch (error) {
      console.log("getSingleExpensesData-> Error Getting Expenses Data: ", error);
    }
    setIsLoading(false);
  };

  const getClientExpenseCode = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        TypeOfObjectReturned: "",
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ clientId: selectedClientData?.ClientId }],
        SortList: [
          {
            FieldName: "Id",
            Direction: "ASC"
          }
        ]
      };

      const clientExpenseCodeResponse = await Postrequestcall(
        FETCH_CLIENT_EXPENSE_CODES,
        obj,
        loginData?.accessToken
      );
      if (clientExpenseCodeResponse?.status === 200) {
        const newData = [
          {
            id: -1,
            name: TEXT_SELECT_CODE,
            disabled: true
          },
          ...clientExpenseCodeResponse?.data?.data
        ];
        setExpenseCodeData(newData);
        return clientExpenseCodeResponse?.data?.data;
      } else {
        console.log("getClientExpenseCode-> Error Fetching Client Expense Code Data");
      }
    } catch (error) {
      console.log("getClientExpenseCode-> Error Fetching Client Expense Code Data: ", error);
    }
  };
  const getClientCurrencies = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: false
      };

      const clientCurrencieResponse = await Postrequestcall(
        FETCH_CLIENT_CURRENCIES_V2,
        obj,
        loginData?.accessToken
      );
      if (clientCurrencieResponse?.status === 200) {
        const newData = [...clientCurrencieResponse?.data?.data];
        setCurrencyData(newData);
        return newData;
      } else {
        console.log("getClientCurrencies->Error Getting Client Currency Data");
      }
    } catch (error) {
      console.log("getClientCurrencies->Error Getting Client Currency Data: ", error);
    }
  };

  const getClientJob = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [{ clientId: selectedClientData?.ClientId, active: true }]
      };

      const clientJobResponse = await Postrequestcall(
        FETCH_CLIENT_JOBS,
        obj,
        loginData?.accessToken
      );
      if (clientJobResponse?.status === 200) {
        const newData = [
          {
            id: -1,
            jobCode: "Select Job",
            disabled: true
          },
          ...clientJobResponse?.data?.data
        ];
        setJobData(newData);
      } else {
        console.log("getClientJob-> Error Getting Client Jobs");
      }
    } catch (error) {
      console.log("getClientJob-> Error Getting Client Jobs: ", error);
    }
  };

  const getClientUdFieldData = async (jobId) => {
    try {
      const udFieldResponse = await Getrequestcall(
        FETCH_CLIENT_UD_FIELDS_BY_CLIENT_ID + `${selectedClientData?.ClientId}/2/${jobId}`,
        loginData?.accessToken
      );
      if (udFieldResponse?.status === 200) {
        setUdFieldData(udFieldResponse?.data?.data[0]);
      } else {
        console.log("getClientUdFieldData-> Error Getting Client UD Field Data");
      }
    } catch (error) {
      console.log("getClientUdFieldData-> Error Getting Client UD Field Data: ", error);
    }
  };
  const shouldDisable = () => {
    return (
      clientExpensesSaveData.date !== null &&
      clientExpensesSaveData.title !== "" &&
      clientExpensesSaveData.code.id !== -1 &&
      clientExpensesSaveData.job.id !== -1 &&
      clientExpensesSaveData.amount !== ""
    );
  };
  const saveClientExpensesData = async () => {
    try {
      setIsLoading(true);
      if (clientExpensesSaveData.deleteImgId?.length > 0) {
        await handleDeleteReceiptImage();
      }
      const obj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: clientExpensesSaveData.id,
            ClientEmployeeId: selectedClientData?.ClientEmployeeId,
            DateSubmitted:
              dayjs(clientExpensesSaveData?.date).toISOString() ?? clientExpensesSaveData?.date,
            Title: clientExpensesSaveData.title,
            ClientExpenseCodeId: clientExpensesSaveData.code.id,
            ClientJobId: clientExpensesSaveData.job.id,
            Mileage: clientExpensesSaveData.mileageValue,
            MileageUnit: clientExpensesSaveData.milageUnit.unitLabel,
            SubTotal: clientExpensesSaveData.amount,
            Tax: clientExpensesSaveData.tax === "" ? 0 : clientExpensesSaveData.tax,
            Tip: clientExpensesSaveData.tip === "" ? 0 : clientExpensesSaveData.tip,
            Total: getTotal(),
            PaidWith: clientExpensesSaveData.paidWith,
            Description: clientExpensesSaveData.description,
            Status: clientExpensesSaveData?.status,
            CurrencyId: clientExpensesSaveData.currType.id,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };

      const isRecordSaved = await Postrequestcall(
        SAVE_CLIENT_EXPENSES,
        obj,
        loginData?.accessToken
      );
      if (isRecordSaved?.status === 200) {
        if (clientExpensesSaveData.imageFile?.length > 0) {
          await handleSaveReceiptImage(isRecordSaved?.data?.data[0].Id);
        }
        handleClose(true);
      } else {
        console.log("saveClientExpensesData-> Error Saving Client Expenses");
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("saveClientExpensesData-> Error Saving Client Expenses: ", error);
    }
  };
  const handleDeleteReceiptImage = async () => {
    const obj = {
      userId: loginData?.userInformation?.UserId,
      returnRecordError: true,
      softDelete: false,
      deleteList: [
        ...clientExpensesSaveData?.deleteImgId?.map((id) => {
          return {
            id: id
          };
        })
      ]
    };
    await Postrequestcall(DELETE_CLIENT_EXPENSES_RECEIPTS, obj, loginData?.accessToken);
  };
  const handleSaveReceiptImage = async (Id) => {
    const promises = clientExpensesSaveData?.imageFile?.map(async (pic) => {
      const formData = new FormData();
      formData.append("Id", 0);
      formData.append("ClientExpenseId", Id);
      formData.append("PictureUrl", pic.file);
      formData.append("PictureDateTime", dayjs().toISOString());
      formData.append("ModifiedBy", loginData?.userInformation?.UserId);
      return Fileuploadrequestcall(SAVE_CLIENT_EXPENSE_RECEIPT, formData, loginData?.accessToken);
    });
    await Promise.all(promises);
  };

  const handleInputChange = (value, field) => {
    if (field === "code") {
      setClientExpensesSaveData((prevState) => ({
        ...prevState,
        [field]: value,
        job: []
      }));
      getClientUdFieldData(value.id);
    } else if (field === "title" || field === "description") {
      let inputValue = value;
      inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
      setClientExpensesSaveData((prevState) => ({
        ...prevState,
        [field]: inputValue
      }));
    } else {
      if (field === "amount" || field === "tax" || field === "tip" || field === "mileageValue") {
        if (
          typeof value === "string" &&
          (value.includes("$") || value.includes("£") || value.includes("₹"))
        ) {
          value = value.replace(/[$£₹]/g, "").trim();
        }
        const regex = /^[+]?\d{0,6}(\.\d{0,2})?$/;
        const numericValue = parseFloat(value);

        // Check for amount field max limit of 1000
        if (field === "amount" && value !== "" && numericValue > 1000) {
          const currencySymbol = clientExpensesSaveData?.currType?.currencySign || "";
          toast.error(`Amount cannot exceed ${currencySymbol} 1000`);
          return;
        }

        if (regex.test(value) || value === "") {
          setClientExpensesSaveData((prevState) => ({
            ...prevState,
            [field]: value
          }));
        }
        return;
      }
      setClientExpensesSaveData((prevState) => ({
        ...prevState,
        [field]: value
      }));
    }
  };

  const handleUploadBtnCLick = () => {
    imgRef.current.click();
  };
  const handleSelectImage = (e) => {
    let files = e.target.files;
    let updatedImageFiles = [];

    Array.from(files)?.forEach((file) => {
      // Only allow image files
      if (file.type.startsWith("image/")) {
        const fileURL = URL.createObjectURL(file);
        updatedImageFiles.push({ file, fileURL });
      }
    });

    if (updatedImageFiles.length === 0) {
      toast.error("Only image files are allowed.");
      e.target.value = "";
      return;
    }

    setClientExpensesSaveData((prevData) => ({
      ...prevData,
      imageFile: [...prevData.imageFile, ...updatedImageFiles]
    }));

    e.target.value = "";
  };

  const getTotal = () => {
    return (
      Number(clientExpensesSaveData.tax) +
      Number(clientExpensesSaveData.tip) +
      Number(clientExpensesSaveData.amount)
    );
  };

  const removeImg = (type, index) => {
    if (type === "new") {
      if (
        clientExpensesSaveData &&
        clientExpensesSaveData.imageFile &&
        Array.isArray(clientExpensesSaveData.imageFile)
      ) {
        clientExpensesSaveData.imageFile.splice(index, 1);

        setClientExpensesSaveData({
          ...clientExpensesSaveData,
          imageFile: [...clientExpensesSaveData.imageFile]
        });
      }
    } else if (type === "old") {
      const id = [...clientExpensesSaveData.deleteImgId, index];
      const updatedOldImg = clientExpensesSaveData.imageFileOld?.filter((img) => img.id !== index);
      setClientExpensesSaveData({
        ...clientExpensesSaveData,
        deleteImgId: id,
        imageFileOld: updatedOldImg
      });
    }
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <>
          <Box className="client-modal-responsive">
            {isLoading ? (
              <Stack
                height={"300px"}
                width={"100%"}
                alignItems={"center"}
                justifyContent={"center"}>
                <Loader />
              </Stack>
            ) : (
              <>
                <Grid size={12}>
                  <IconButton
                    sx={{
                      display: "flex",
                      justifySelf: "flex-end",
                      color:
                        selectedClientData?.AccentColor !== undefined &&
                        selectedClientData?.AccentColor
                          ? selectedClientData?.AccentColor
                          : BILightGrey
                    }}
                    onClick={handleClose}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
                <Grid
                  maxHeight={"500px"}
                  overflow={"scroll"}
                  sx={{
                    scrollbarWidth: "none"
                  }}
                  container
                  spacing={1}>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="body1">{TEXT_DATE}</Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            size: "small",
                            readOnly: true,
                            inputProps: {
                              value: dayjs(clientExpensesSaveData.date).isSame(dayjs(), "day")
                                ? `${dayjs(clientExpensesSaveData.date).format("DD-MM-YYYY")}  (Today)`
                                : dayjs(clientExpensesSaveData.date).format("DD-MM-YYYY")
                            }
                          }
                        }}
                        sx={{
                          "& fieldset": { border: "none" },
                          "& .MuiSvgIcon-root": {
                            color: selectedClientData?.AccentColor
                          }
                        }}
                        format="MMMM DD YYYY"
                        value={dayjs(clientExpensesSaveData.date)}
                        onChange={(newDate) => {
                          handleInputChange(newDate, "date");
                        }}
                        className="ticket-picker add-support"
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid size={12}>
                    <Typography variant="body1">{TEXT_TITLE}</Typography>
                    <TextField
                      size="small"
                      variant="outlined"
                      required
                      fullWidth
                      onChange={(e) => handleInputChange(e.target.value, "title")}
                      value={clientExpensesSaveData.title}
                      placeholder={TEXT_TITLE_PLACEHOLDER}
                      className="add-support"
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                    />
                  </Grid>
                  <Grid size={12}>
                    <Typography variant="body1">{TEXT_CODE}</Typography>
                    <Select
                      size="small"
                      variant="outlined"
                      required
                      fullWidth
                      value={clientExpensesSaveData.code.id}
                      onChange={(e) => {
                        const selected = expenseCodeData?.find(
                          (option) => option?.id === e.target.value
                        );
                        handleInputChange(selected, "code");
                      }}
                      style={{
                        backgroundColor: "#e4e4e4",
                        marginTop: "10px",
                        borderRadius: "10px"
                      }}
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                      className="add-support"
                      renderValue={(selectedValue) => {
                        if (selectedValue === -1) {
                          return TEXT_SELECT_CODE;
                        }
                        const selectedOption = expenseCodeData?.find(
                          (option) => option?.id === selectedValue
                        );
                        return selectedOption
                          ? `${selectedOption.name} - ${selectedOption.expenseCode}`
                          : TEXT_SELECT_CODE;
                      }}>
                      {expenseCodeData?.map((option, index) => (
                        <MenuItem key={index} value={option?.id} disabled={option?.disabled}>
                          {option?.name} - {option?.expenseCode}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  {clientExpensesSaveData.code.requireJob ? (
                    <Grid size={12}>
                      <Typography variant="body1">{TEXT_JOB}</Typography>
                      <Select
                        size="small"
                        variant="outlined"
                        required
                        fullWidth
                        value={clientExpensesSaveData.job?.id ?? ""}
                        onChange={(e) => {
                          const selected = jobData?.find((option) => option?.id === e.target.value);
                          handleInputChange(selected, "job");
                        }}
                        style={{
                          backgroundColor: "#e4e4e4",
                          marginTop: "10px",
                          borderRadius: "10px"
                        }}
                        sx={{
                          "& fieldset": { border: "none" }
                        }}
                        className="add-support"
                        renderValue={(selectedValue) => {
                          const selectedOption = jobData.find(
                            (option) => option?.id === selectedValue
                          );
                          return selectedOption ? `${selectedOption.name}` : "";
                        }}>
                        {jobData?.map((option, index) => (
                          <MenuItem key={index} value={option?.id} disabled={option?.disabled}>
                            {option?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  ) : clientExpensesSaveData?.job?.length !== 0 &&
                    clientExpensesSaveData?.job?.id > 0 ? (
                    <Grid size={12}>
                      <Typography variant="body1">{TEXT_JOB}</Typography>
                      <Select
                        size="small"
                        variant="outlined"
                        required
                        fullWidth
                        value={clientExpensesSaveData.job?.id}
                        onChange={(e) => {
                          const selected = jobData?.find((option) => option?.id === e.target.value);
                          handleInputChange(selected, "job");
                        }}
                        style={{
                          backgroundColor: "#e4e4e4",
                          marginTop: "10px",
                          borderRadius: "10px"
                        }}
                        sx={{
                          "& fieldset": { border: "none" }
                        }}
                        className="add-support"
                        renderValue={(selectedValue) => {
                          const selectedOption = jobData?.find(
                            (option) => option?.id === selectedValue
                          );
                          return selectedOption ? `${selectedOption.name}` : "";
                        }}>
                        {jobData?.map((option, index) => (
                          <MenuItem key={index} value={option?.id} disabled={option?.disabled}>
                            {option?.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                  ) : null}
                  {clientExpensesSaveData.code.requireMileage && (
                    <Grid container size={12} alignItems={"end"}>
                      <Grid size={{ xs: 12 }}>
                        <Typography variant="body1">{TEXT_MILEAGE}</Typography>
                      </Grid>
                      <Grid size={{ xs: 10, sm: 7 }}>
                        <TextField
                          size="small"
                          variant="outlined"
                          fullWidth
                          required
                          onChange={(e) => handleInputChange(e.target.value, "mileageValue")}
                          value={clientExpensesSaveData.mileageValue}
                          placeholder="0.00"
                          className="add-support"
                          sx={{
                            "& fieldset": { border: "none" }
                          }}
                        />
                      </Grid>
                      <Grid size={{ xs: 12, sm: 4 }}>
                        <Select
                          size="small"
                          variant="outlined"
                          fullWidth
                          required
                          value={clientExpensesSaveData.milageUnit.id} // Use only the `id` for the value
                          onChange={(e) => {
                            const selected = unitData?.find(
                              (option) => option?.id === e.target.value
                            ); // Update with unitData
                            handleInputChange(selected, "milageUnit"); // Set full object on change
                          }}
                          style={{
                            backgroundColor: "#e4e4e4",
                            marginTop: "10px",
                            borderRadius: "10px",
                            color: selectedClientData?.AccentColor
                          }}
                          sx={{
                            "& fieldset": { border: "none" }
                          }}
                          className="add-support"
                          renderValue={(selectedValue) => {
                            const selectedOption = unitData?.find(
                              (option) => option?.id === selectedValue
                            ); // Update with unitData
                            return selectedOption ? selectedOption.unitLabel : "";
                          }}>
                          {unitData?.map((option, index) => (
                            <MenuItem
                              key={index}
                              value={option?.id}
                              disabled={option?.disabled}
                              sx={{ color: selectedClientData?.AccentColor }}>
                              {option?.unitLabel}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                    </Grid>
                  )}
                  <Grid container size={{ xs: 12 }} alignItems="end">
                    <Grid size={{ xs: 12 }}>
                      <Typography variant="body1">
                        {isMore ? TEXT_SUB_TOTAL : TEXT_AMOUNT}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                      <Select
                        size="small"
                        variant="outlined"
                        fullWidth
                        required
                        value={clientExpensesSaveData.currType.id}
                        onChange={(e) => {
                          const selected = currencyData?.find(
                            (option) => option?.id === e.target.value
                          );
                          handleInputChange(selected, "currType");
                        }}
                        style={{
                          backgroundColor: "#e4e4e4",
                          marginTop: "10px",
                          borderRadius: "10px",
                          color: selectedClientData?.AccentColor
                        }}
                        sx={{
                          "& fieldset": { border: "none" }
                        }}
                        className="add-support"
                        renderValue={(selectedValue) => {
                          const selectedOption = currencyData?.find(
                            (option) => option?.id === selectedValue
                          );
                          return selectedOption
                            ? `${selectedOption.currencyCode}${
                                selectedOption.currencySign ? " " + selectedOption.currencySign : ""
                              }`
                            : "";
                        }}>
                        {currencyData?.map((option, index) => (
                          <MenuItem
                            key={index}
                            value={option?.id}
                            disabled={option?.disabled}
                            sx={{ color: selectedClientData?.AccentColor }}>
                            {option?.currencyCode}
                            {option?.currencySign}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid size={{ xs: 10, sm: 7 }}>
                      <TextField
                        size="small"
                        variant="outlined"
                        fullWidth
                        required
                        onChange={(e) => handleInputChange(e.target.value, "amount")}
                        value={clientExpensesSaveData.amount}
                        placeholder="0.00"
                        className="add-support"
                        sx={{
                          "& fieldset": { border: "none" }
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 2, sm: 1 }}>
                      <IconButton onClick={() => setIsMore(!isMore)}>
                        {isMore ? (
                          <ArrowDropUpIcon sx={{ color: selectedClientData?.AccentColor }} />
                        ) : (
                          <ArrowDropDownIcon sx={{ color: selectedClientData?.AccentColor }} />
                        )}
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Grid container size={{ xs: 12 }} alignItems="end">
                    {isMore && (
                      <>
                        <Grid size={{ xs: 6 }}>
                          <Typography variant="body1" color="grey">
                            {TEXT_TAX_OPTIONAL}{" "}
                          </Typography>
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                          <Typography variant="body1" color="grey">
                            {TEXT_TIP_OPTIONAL}{" "}
                          </Typography>
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                          <TextField
                            size="small"
                            variant="outlined"
                            fullWidth
                            required
                            onChange={(e) => handleInputChange(e.target.value, "tax")}
                            value={
                              clientExpensesSaveData?.currType?.currencySign +
                              " " +
                              clientExpensesSaveData.tax
                            }
                            placeholder="0.00"
                            className="add-support"
                            sx={{
                              "& fieldset": { border: "none" }
                            }}
                          />
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                          <TextField
                            size="small"
                            variant="outlined"
                            fullWidth
                            required
                            onChange={(e) => handleInputChange(e.target.value, "tip")}
                            value={
                              clientExpensesSaveData?.currType?.currencySign +
                              " " +
                              clientExpensesSaveData.tip
                            }
                            placeholder="0.00"
                            className="add-support"
                            sx={{
                              "& fieldset": { border: "none" }
                            }}
                          />
                        </Grid>
                        <Grid size={12}>
                          <Typography variant="body1" color="grey">
                            {TEXT_TOTAL}{" "}
                          </Typography>
                        </Grid>
                        <Grid size={12}>
                          <Typography variant="body1" color="grey">
                            {clientExpensesSaveData?.currType?.currencySign + " " + getTotal()}
                          </Typography>
                        </Grid>
                      </>
                    )}
                    <FormControl>
                      <Typography variant="body1">{TEXT_SELECT1}</Typography>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="Paid Personally"
                        name="radio-buttons-group">
                        <FormControlLabel
                          onClick={() => handleInputChange(1, "paidWith")}
                          value="Paid Personally"
                          control={
                            <Radio
                              checked={clientExpensesSaveData.paidWith === 1 ? true : false}
                              sx={{
                                color: selectedClientData?.AccentColor, // Color of outer ring
                                "&.Mui-checked": {
                                  color: selectedClientData?.AccentColor // Color of inner circle when checked
                                },
                                "& .MuiRadio-inner": {
                                  backgroundColor: selectedClientData?.AccentColor // Color of the inner circle
                                }
                              }}
                            />
                          }
                          label={TEXT_PAID_PERSONALLY}
                        />
                        <FormControlLabel
                          onClick={() => handleInputChange(2, "paidWith")}
                          value="Paid with company card"
                          control={
                            <Radio
                              checked={clientExpensesSaveData.paidWith === 2 ? true : false}
                              sx={{
                                color: selectedClientData?.AccentColor, // Color of outer ring
                                "&.Mui-checked": {
                                  color: selectedClientData?.AccentColor // Color of inner circle when checked
                                },
                                "& .MuiRadio-inner": {
                                  backgroundColor: selectedClientData?.AccentColor // Color of the inner circle
                                }
                              }}
                            />
                          }
                          label={TEXT_PAID_WITH_COMPANY}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <Typography variant="body1">{TEXT_DESCRIPTION}</Typography>
                    <TextField
                      size="small"
                      fullWidth
                      variant="outlined"
                      required
                      onChange={(e) => handleInputChange(e.target.value, "description")}
                      value={clientExpensesSaveData.description}
                      minRows={4}
                      slotProps={{
                        input: {
                          rows: 4,
                          multiline: true,
                          inputComponent: "textarea"
                        }
                      }}
                      placeholder={TEXT_INCLUDE_ADDTITIONAL_DETAIL}
                      className="add-support"
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12 }} container columnSpacing={1} alignItems={"flex-start"}>
                    <Button
                      variant="outlined"
                      sx={{
                        color: selectedClientData?.AccentColor,
                        borderColor: selectedClientData?.AccentColor,
                        textTransform: "none"
                      }}
                      startIcon={<FileUploadIcon />}
                      onClick={handleUploadBtnCLick}>
                      {TEXT_UPLOAD_RECEIPT}
                    </Button>
                    <input
                      type="file"
                      multiple
                      onChange={handleSelectImage}
                      accept="image/*"
                      ref={imgRef}
                      style={{ display: "none" }}
                    />
                    <Grid
                      overflow={"scroll"}
                      display={"flex"}
                      flexDirection="row"
                      gap={1}
                      size={{ xs: 12 }}
                      sx={{
                        scrollbarWidth: "none",
                        width: "100%",
                        alignItems: "center"
                      }}>
                      {clientExpensesSaveData.imageFile?.length > 0 && (
                        <>
                          {clientExpensesSaveData.imageFile?.map((path, index) => (
                            <span
                              key={index}
                              style={{
                                position: "relative",
                                display: "inline-block"
                              }}>
                              <IconButton
                                sx={{
                                  position: "absolute",
                                  top: "-5px",
                                  right: "0px",
                                  zIndex: 1,
                                  color:
                                    selectedClientData?.AccentColor !== undefined &&
                                    selectedClientData?.AccentColor
                                      ? selectedClientData?.AccentColor
                                      : BILightGrey,
                                  backgroundColor: "rgba(0,0,0,0.3)"
                                }}
                                size="small"
                                onClick={() => removeImg("new", index)}>
                                <CloseIcon />
                              </IconButton>
                              <img
                                onClick={() => {
                                  setPictureViewerOpen(true);
                                  setPictureViewerIndex(index);
                                }}
                                loading="lazy"
                                src={path?.fileURL}
                                alt="expenses receipt"
                                height={"100px"}
                                width={"100px"}
                                style={{ borderRadius: "8px" }}
                              />
                            </span>
                          ))}
                        </>
                      )}
                      {clientExpensesSaveData.imageFileOld?.length > 0 && (
                        <>
                          {clientExpensesSaveData.imageFileOld?.map((path, index) => (
                            <span
                              key={index}
                              style={{
                                position: "relative",
                                display: "inline-block"
                              }}>
                              <IconButton
                                sx={{
                                  position: "absolute",
                                  top: "-5px",
                                  right: "0px",
                                  color: "red",
                                  zIndex: 1
                                }}
                                size="small"
                                onClick={() => removeImg("old", path.id)}>
                                <CloseIcon />
                              </IconButton>

                              {/* Image */}
                              <img
                                src={path?.thumbFileUrl}
                                alt="expenses receipt"
                                height={"100px"}
                                width={"100px"}
                                loading="lazy"
                                style={{ borderRadius: "10px" }}
                              />
                            </span>
                          ))}
                        </>
                      )}
                    </Grid>
                  </Grid>
                  <Grid size={12} sx={{ overflowX: "auto", display: "flex" }} marginTop={1}>
                    <Button
                      disabled={!shouldDisable() || isLoading}
                      variant="contained"
                      fullWidth
                      onClick={saveClientExpensesData}
                      sx={{
                        backgroundColor: selectedClientData?.AccentColor,
                        textTransform: "none"
                      }}>
                      {TEXT_SUBMIT}
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </Box>
        </>
      </Modal>
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewerOpen(false)}
        pictures={clientExpensesSaveData?.imageFile?.map((img) => {
          return { src: img.fileURL };
        })}
        viewerIndex={pictureViewerIndex}
      />
    </div>
  );
}

export default AddClientExpenses;
